import React, { useState, useEffect } from "react"
const PC_WIDTH_THRESHOLD = 860
export const PCViewContext = React.createContext(true)

export const PCViewRoot = (props) => {
  const [isPC, setIsPC] = useState(window.innerWidth >= PC_WIDTH_THRESHOLD)
  const watchResize = () => {
    setIsPC(window.innerWidth >= PC_WIDTH_THRESHOLD)
  }

  useEffect(() => {
    window.addEventListener("resize", watchResize)
    return () => {
      window.removeEventListener("resize", watchResize)
    }
  }, [])

  return (
    <PCViewContext.Provider value={isPC}>
      {props.children}
    </PCViewContext.Provider>
  )
}
